import React from 'react'
import UserAvatar from './UserAvatar'
import AccountCircle from '@mui/icons-material/AccountCircle'
import UserAuthContainer from '../Containers/UserAuthContainer'

const CurrentUserAvatar = ({ size = 'smallAvatar', withName = false }) => {
  const container = UserAuthContainer.useContainer()

  if (container.isAuthed()) {
  return (
      <UserAvatar
        anearUser={container.anearUser()}
        withName={withName}
        size={size}
      />
    )
  }

  // Unauthenticated: show higher-contrast, slightly larger icon so it stands out
  return (
    <AccountCircle
      sx={{
        height: 32,
        width: 32,
        color: '#E5E7EB'
      }}
    />
  )
}

export default CurrentUserAvatar
